import {Component, Input, Output, EventEmitter, OnInit, SimpleChanges, OnChanges, OnDestroy, ViewChild} from '@angular/core';
import {IonInput} from '@ionic/angular';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {ModalitaModificaQuantita} from '../../../_models/AccountOrganizzazione';
import {SbloccoEffimero} from '../../../_helpers/sblocco-effimero';

@Component({
    selector: 'app-quantita-input',
    templateUrl: './quantita-input.component.html',
    styleUrls: ['./quantita-input.component.scss'],
    standalone: false
})
export class QuantitaInputComponent implements OnInit, OnChanges, OnDestroy {
  @Input() udM = '';
  @Input() quantita = 0;
  @Output() quantitaChange = new EventEmitter<number>();
  @Input() quantitaResidua = 0;
  @Input() color = 'success';

  inputQta = 0;
  partialQta = 0;

  private lastEmittedValue: number | null = null;

  @ViewChild('qtaInputRef') qtaInputRef: IonInput;

  /** Sblocco della modalità ConSblocco (feature 150): si richiude al blur. */
  readonly sblocco = new SbloccoEffimero();

  constructor(private organizzazioniService: OrganizzazioniService) { }

  /**
   * Modalità configurata per l'operatore. Letta qui e non passata da fuori: così nessuno dei 21
   * chiamanti di app-quantita-input deve cambiare (come per app-lotto-input).
   */
  get modalita(): ModalitaModificaQuantita {
    return this.organizzazioniService.tipoModificaQuantita;
  }

  /**
   * Digitazione (e quindi scansione) bloccata. I pulsanti non guardano questo getter: restano
   * attivi in tutte le modalità, perché sono il modo di impostare la quantità senza scriverla.
   */
  get inputBloccato(): boolean {
    if (this.modalita === ModalitaModificaQuantita.Fisso) {
      return true;
    }
    return this.modalita === ModalitaModificaQuantita.ConSblocco && !this.sblocco.sbloccato;
  }

  get showLucchetto(): boolean {
    return this.modalita === ModalitaModificaQuantita.ConSblocco;
  }

  get placeholderQta(): string {
    return this.inputBloccato ? 'Usa i pulsanti' : 'Quantità';
  }

  toggleQtaLock(): void {
    // Il fuoco va nel campo appena si apre: altrimenti servirebbe un secondo tap.
    this.sblocco.alterna(() => this.qtaInputRef?.setFocus());
  }

  onQtaBlur(): void {
    if (this.modalita === ModalitaModificaQuantita.ConSblocco) {
      this.sblocco.richiudiAlBlur();
    }
  }

  ngOnDestroy(): void {
    this.sblocco.dispose();
  }

  ngOnInit(): void {
    this.inputQta = this.quantita;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['quantita']) {
      const newValue = changes['quantita'].currentValue;
      // ignora se è un rimbalzo del valore che abbiamo emesso noi
      if (newValue !== this.lastEmittedValue) {
        this.inputQta = newValue;
        this.partialQta = 0;
        this.lastEmittedValue = null;
      }
    }
  }

  addToPartial = () => {
    this.partialQta += this.inputQta;
    this.inputQta = 0;
    this.lastEmittedValue = this.partialQta;
    this.quantitaChange.emit(this.partialQta);
  }

  changeLavorata = (qta: number) => {
    this.inputQta += qta;
    const emitValue = this.inputQta + this.partialQta;
    this.lastEmittedValue = emitValue;
    this.quantitaChange.emit(emitValue);
  };

  setLavorata = (qta: number) => {
    this.inputQta = qta;
    this.partialQta = qta === 0 ? 0 : this.partialQta;
    const emitValue = this.inputQta + this.partialQta;
    this.lastEmittedValue = emitValue;
    this.quantitaChange.emit(emitValue);
  };
}
